import { PROMOTION_ERROR_CODE } from '../models/enums';

export const ERRORS_MSG = {
  [PROMOTION_ERROR_CODE.TOO_MANY_ATTEMPTS]: 'common.error.promotion.maxAttemptExceeded',
};
